import _objectSpread from "/data/bash/localbuild/webclient/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import LangSelect from '@/components/LangSelect';
import Search from '@/components/HeaderSearch';
import AboutUs from '@/components/AboutUs';
import ReadSetting from '@/components/ReadSetting';
import { queryDocType, setDocType, personalCenter } from '@/api/user';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    ErrorLog: ErrorLog,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    LangSelect: LangSelect,
    Search: Search,
    AboutUs: AboutUs,
    ReadSetting: ReadSetting
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'name', 'avatar', 'username', 'code', 'typeName', 'roleName', 'doctype'])),
  data: function data() {
    return {
      dialogVisible: false,
      readSettingVisible: false,
      userInfo: {},
      userType: [],
      iconName: 'user'
    };
  },
  created: function created() {
    this.iconName = this.username.charAt(this.username.length - 1);
  },
  mounted: function mounted() {
    this.getUserInfo();
  },
  methods: {
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this = this;

      this.$store.dispatch('user/logingout').then(function () {
        _this.$message({
          message: '退出登录成功',
          type: 'success'
        });

        _this.$router.push('/login');
      });
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      personalCenter().then(function (res) {
        _this2.userInfo = res.list ? res.list[0] : {};

        if (_this2.userInfo.userid) {
          _this2.getDoctorType();
        } else {
          // 退出登录
          _this2.$store.dispatch('user/clearData');
        }
      });
    },
    getDoctorType: function getDoctorType() {
      var _this3 = this;

      queryDocType().then(function (res) {
        _this3.userType = res.list ? res.list : [];
      }).catch(function (error) {
        console.log('catch:', error);
      });
    },
    handleChange: function handleChange(doctorid) {
      var _this4 = this;

      var params = {
        doctorid: doctorid
      };
      this.$store.dispatch('user/setDocType', this.qs.stringify(params)).then(function () {
        _this4.getUserInfo();

        _this4.$router.push({
          path: '/studyList',
          query: {
            doctorid: doctorid
          }
        });
      });
    },
    handleRoutList: function handleRoutList(doctorid) {
      var _this5 = this;

      var params = {
        doctorid: doctorid
      };
      this.$store.dispatch('user/setDocType', this.qs.stringify(params)).then(function () {
        _this5.getUserInfo();

        _this5.$router.push({
          path: '/studyList',
          query: {
            doctorid: doctorid
          }
        });
      });
    }
  }
};